var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pending),expression:"!pending"}],ref:"image",staticClass:"pd_modal_image",attrs:{"src":_vm.image}})}
var staticRenderFns = []

export { render, staticRenderFns }